<template>
  <div class="headers-filter-container">
    <el-popover @show="show" :width="200" trigger="hover" placement="bottom-start" popper-class="top-user-popover">
      <!-- 触发 -->
      <span slot="reference" class="headers-filter-reference">
        <span>进度</span>
        <i class="el-icon-Group-49" :class="{ active: isActive }"></i>
      </span>

      <!-- 主体 -->
      <div class="headers-filter-main">
        <el-checkbox-group class="margins" v-model="searchParams.schedules" @change="handleScheduleChange">
          <div v-for="item in list" :key="item.value" class="mb-10">
            <el-checkbox :label="item.value">{{ item.label }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>

      <!-- 按钮 -->
      <div class="headers-filter-btn">
        <el-button @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleScreen">筛选</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'ScheduleHeader',
  props: {
    searchModel: { type: Object, default: () => ({}) },
  },
  computed: {
    isActive() {
      return this.searchModel?.schedules?.length > 0;
    },
  },
  watch: {
    isActive(val) {
      if (!val) {
        this.searchParams = { schedules: [] };
      }
    },
  },
  data() {
    return {
      searchParams: { schedules: [] },
      list: [
        { label: '排队中', value: 1 },
        { label: '导出中', value: 2 },
        { label: '导出完成', value: 3 },
        { label: '失败', value: 4 },
      ],
    };
  },
  methods: {
    handleScheduleChange() {
      const { schedules } = this.searchParams;
      this.searchParams.schedules = schedules;
    },
    // 重置
    handleReset() {
      this.$emit('on-schedules', { schedules: [] });
    },
    // 筛选
    handleScreen() {
      this.$emit('on-schedules', this.searchParams);
    },
    // 展示
    show() {
      const { schedules = [] } = this.searchModel || {};
      this.searchParams = { schedules: [...schedules] };
    },
  },
};
</script>

<style scoped lang="scss">
.headers-filter-container {
  width: 100%;
}
.headers-filter-btn {
  text-align: left;
  padding: 20px 0 10px 20px;
}
/* 过滤 */
.el-icon-Group-49 {
  top: -2px;
  cursor: pointer;
  padding-left: 2px;
  position: relative;
}

.el-icon-Group-49.active {
  color: #2695FA;
}

.margins {
  padding: 10px 0 10px 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
